/**
 * API Configuration
 *
 * This file centralizes API configuration settings and provides
 * utility functions for accessing API URLs and other settings.
 */

// Default API URL as fallback
// const DEFAULT_API_URL = 'https://api.marki-to.com/api'
const DEFAULT_API_URL = 'http://127.0.0.1:9000/api'

/**
 * Get the API base URL from environment variables with fallback
 * @returns {string} The API base URL
 */
export const getApiUrl = () => {
  // For Vite, use import.meta.env
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    return import.meta.env.VITE_API_URL || import.meta.env.REACT_APP_API_URL || DEFAULT_API_URL
  }

  // For Create React App or other environments
  if (typeof process !== 'undefined' && process.env) {
    return process.env.REACT_APP_API_URL || DEFAULT_API_URL
  }

  return DEFAULT_API_URL
}

/**
 * Build a full API endpoint URL
 * @param {string} endpoint - The API endpoint path
 * @returns {string} The full API URL
 */
export const buildApiUrl = (endpoint) => {
  const baseUrl = getApiUrl()
  return `${baseUrl}/${endpoint}`
}

export const buildWebSocketUrl = (endpoint, token) => {
  const apiUrl = getApiUrl()
  const wsBaseUrl = apiUrl
    .replace(/^https:\/\//, 'wss://')
    .replace(/^http:\/\//, 'ws://')
    .replace(/\/api\/?$/, '')
  const separator = endpoint.includes('?') ? '&' : '?'
  const tokenQuery = token ? `${separator}token=${encodeURIComponent(token)}` : ''
  return `${wsBaseUrl}/${endpoint}${tokenQuery}`
}

/**
 * Get authorization headers with token
 * @param {string|null} token - The authentication token
 * @returns {Object} Headers object
 */
export const getAuthHeaders = (token) => {
  return token ? { Authorization: `Token ${token}` } : {}
}

export default {
  getApiUrl,
  buildApiUrl,
  buildWebSocketUrl,
  getAuthHeaders,
  DEFAULT_API_URL,
}
